import Avatar from './avatar';
export { AvatarIcons } from './avatar';
export default Avatar;
export * from './interface';